import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/sports/ticker.png',
  title: 'Ticker',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Sports Ticker',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'image',
          name: 'Flare',
          editable: false,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/flare.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 884,
            left: 1089,
            width: 328,
            height: 178,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Ticker Text',
          locked: false,
          text: '<p>This is the ticker text Lorem ipsum dolo sit amet, consectetur adipiscing elit, sed do eiusmod temporA&nbsp;</p>',
          cssClasses: '',
          animation: true,
          animationInStyle: 'none',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'none',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: false,
          whiteSpace: 'nowrap',
          ticker: true,
          tickerCrawlSpeed: 2000,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 973,
            left: 459,
            width: 1014,
            height: 43,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto Condensed',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 28,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Channel Name',
          locked: false,
          text: '<p><strong><em>Channel Name</em></strong></p>',
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ellipsis: true,
          whiteSpace: 'normal',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 974,
            left: 1531,
            width: 402,
            height: 45,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: 'Roboto',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 28,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Red Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 5,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: 0,
          boxShadowY: 0,
          boxShadowBlur: 5,
          boxShadowSpread: 1,
          boxShadowColor: 'rgba(255, 255, 255, 0.4)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(255, 37, 60)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: 'rgb(0, 73, 168)',
          gradientColorTwo: 'rgb(0, 73, 168)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomRightRadius: 10,
          borderBottomLeftRadius: 10,
          blur: false,
          blurSize: 10,
          skewX: -30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 969,
            left: 1509,
            width: 459,
            height: 55,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Black Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 5,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: 0,
          boxShadowY: 0,
          boxShadowBlur: 5,
          boxShadowSpread: 2,
          boxShadowColor: 'rgba(255, 255, 255, 0.4)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 0, 0)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: 'rgb(0, 73, 168)',
          gradientColorTwo: 'rgb(0, 73, 168)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomRightRadius: 10,
          borderBottomLeftRadius: 10,
          blur: false,
          blurSize: 10,
          skewX: -30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 968,
            left: 436,
            width: 1067,
            height: 55,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'image',
          name: 'Logo',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/logos/tagboard-hash-white.png`,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 981,
            left: 379,
            width: 35,
            height: 31,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Blue Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          loopingAnimation: false,
          loopingAnimationStyle: 'flip',
          loopingAnimationDuration: 800,
          loopingAnimationDelay: 5000,
          border: true,
          borderWidth: 5,
          borderColor: 'rgb(255, 255, 255)',
          boxShadow: true,
          boxShadowX: 0,
          boxShadowY: 0,
          boxShadowBlur: 5,
          boxShadowSpread: 2,
          boxShadowColor: 'rgba(255, 255, 255, 0.4)',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 36, 84)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: 'rgb(0, 73, 168)',
          gradientColorTwo: 'rgb(0, 73, 168)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomRightRadius: 10,
          borderBottomLeftRadius: 10,
          blur: false,
          blurSize: 10,
          skewX: -30,
          skewY: 0,
          rotate: 0,
          styles: {
            top: 969,
            left: -28,
            width: 459,
            height: 55,
            opacity: 1,
          },
        },
      ],
    };
  },
};
